"use client";

import { c as _c } from "react/compiler-runtime";
import { Landmark } from "lucide-react";
import { StatusBanner, StatusBannerRow, StatusBannerContent } from "@/components/ui/status-banner";
import { PAYMENT_PROCESSING_COPY } from "../lib/payment-processing";
interface PaymentProcessingBannerProps {
  className?: string;
}

/**
 * Informational brand banner for a bank debit (PayTo) in flight — the
 * healthy-state `payment_processing` restriction banner (spec
 * billing/2026-10-01-009 §5.2 / §5.6, D7). It is never a warning: brand
 * purple, not amber, with no CTA because there is nothing to do but wait.
 * Webhooks clear the condition, and the banner with it.
 */
export function PaymentProcessingBanner(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-black/15 ring-1 ring-white/25"><Landmark className="h-4 w-4 text-white" aria-hidden={true} /></span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <StatusBannerRow><StatusBannerContent className="flex items-center gap-3">{t1}<p className="text-sm text-white"><span className="font-medium">{PAYMENT_PROCESSING_COPY.bannerTitle}</span><span> · {PAYMENT_PROCESSING_COPY.bannerBody}</span></p></StatusBannerContent></StatusBannerRow>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <StatusBanner color="purple" className={className} role="status" data-testid="payment-processing-banner">{t2}</StatusBanner>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}